import React from 'react';
import { QuoteIcon } from 'lucide-react';
import type { Voice } from '../data/testimonials';
type TestimonialsProps = {
  voices: Voice[];
  title?: string;
  background?: 'white' | 'cream';
};
export function Testimonials({
  voices,
  title = 'What Gestalt practitioners say',
  background = 'cream'
}: TestimonialsProps) {
  const bg = background === 'white' ? 'bg-white' : 'bg-cream';
  return <section aria-label={title} className={`w-full text-ink ${bg}`} data-id="element-312" data-mp="36ziobgqaqmpu">
      <div className="mx-auto max-w-5xl px-5 py-16 sm:py-20" data-id="element-313" data-mp="36wmr5um9w22g">
        <div className="text-center" data-id="element-314" data-mp="31ybezd8i9fh2">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-terra-deep" data-id="element-315" data-mp="2x0tfsekaiem9">
            In their own words
          </p>
          <h2 className="chalk-underline mt-3 font-display text-[28px] text-sage sm:text-5xl" data-id="element-316" data-mp="2s2i1nrmyphy8">
            {title}
          </h2>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-317" data-mp="v7c8jc02nfs1">
          {voices.map(item => <figure key={item.name} className="flex flex-col rounded-2xl border border-sand-dark bg-white p-6 shadow-card" data-id="element-318" data-mp="qb54jor8kecq">
              <QuoteIcon className="h-6 w-6 text-teal" aria-hidden="true" data-id="element-319" data-mp="m62n7z61vxr7" />
              <blockquote className="mb-5 mt-3 font-display text-[18px] italic leading-snug text-sage" data-id="element-320" data-mp="78ab7gzpprhr">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-auto border-t border-sand-dark pt-4" data-id="element-321" data-mp="c8y304vrmcd1">
                <p className="text-sm font-bold text-ink" data-id="element-322" data-mp="zwy1jqzbj726">{item.name}</p>
                <p className="text-[13px] text-ink-soft" data-id="element-323" data-mp="14uhfeps3thtl">{item.role}</p>
                <p className="text-xs text-ink-muted" data-id="element-324" data-mp="q6wcavv8bilo">{item.location}</p>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}